import * as React from 'react';
import {Disclaimers} from '@volkswagen-onehub/components-core';
import {DisclaimerProps} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function Disclaimer({
  text,
  reference,
  id,
}: DisclaimerProps): JSX.Element {
  const disclaimers = React.useMemo(
    () => [
      {
        text,
        reference,
        key: id,
      },
    ],
    [text, reference, id]
  );

  return (
    <div id={id}>
      <Disclaimers disclaimers={disclaimers} />
    </div>
  );
}
